import { ClientData, DefaultBodyType, DefaultErrorType, FetchOptions, queryFn } from './queryFetch.utils';

export const queryFetch = async <T>(clientData: ClientData, options: FetchOptions) =>
  queryFn<T>(clientData, options, options.servicesEndpoint!);

export type ErrorType<ErrorData> = DefaultErrorType<ErrorData>;
export type BodyType<BodyData> = DefaultBodyType<BodyData>;
